import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../../../../images/logo.png'

export const MenuLogo: React.FC = () => {
    return (
        <Link to="/" className="flex flex-row items-center justify-start gap-1">
            <div className="w-9 h-9">
                <img width={40} height={40} src={logo} alt="Логотип" />
            </div>

            <div>
                <div className=" text-[#202020] leading-none font-semibold">
                    ТЕХНОЛОГИИ
                    <br />
                    ЗАКУПОК
                </div>
            </div>
        </Link>
    )
}
